// /src/renderer/analysis/rendering/AnalysisLayout.tsx
import React from 'react';
import {TitleBar} from './TitleBar/TitleBar';
import PanelContainer from './Panels/PanelContainer';
// import './AnalysisLayout.scss';
import styles  from './AnalysisLayout.module.scss';


export interface AnalysisLayoutProps {
  // layoutConfig: LayoutConfig[];
  // selectedLayoutConfig: LayoutConfig;
  // 추가적으로 TitleBar에 필요한 시리즈 정보 등
  // seriesInfo: TitleBarProps;
}

const AnalysisLayout: React.FC<AnalysisLayoutProps> = ({
  // layoutConfig,
  // selectedLayoutConfig,
}) => {
  // const {layoutConfig, selectedLayoutConfig} = useAnalysisPage();
  // const refDownload = React.useRef(true);
  // const refModel = React.useRef<string|null>(null)
  // console.log('')
  return (
    <div className={styles.frame}>
      <TitleBar/>
      <PanelContainer/>
    </div>
  );
};

export default AnalysisLayout;
